<template>
  <div>
    <BaseModal v-model="showModal" size="lg">
      <DocumentPdf :pdfUrl="pdfUrl" />
    </BaseModal>
    <b-form @submit.prevent="onSubmit">
      <AlertDismiss ref="alert" />
      <div v-if="noTemplates">
        <div class="card">
          <div class="card-body text-center">
            Aún no se han creado plantillas de declaración.
          </div>
        </div>
      </div>

      <b-overlay v-else :show="isfetching" variant="white">
        <label>Formulario de declaración:</label>
        <select class="form-control" v-model="selectedTemplate">
          <option disabled :value="null">-- Seleccione un formulario --</option>
          <option v-for="template in templates" :key="template.id" :value="template">
            {{ template.name }}
          </option>
        </select>
      </b-overlay>
      <div v-if="selectedTemplate" class="mt-3">
        <hr>

        <button class="btn btn-outline-primary mb-2" @click="openDocumentModal" type="button">
          <b-icon icon="file-earmark-pdf" class="mr-1" />
          <span class="ms-2">Ver documento</span>
        </button>

        <div v-for="(question, index) in selectedTemplate.questions" :key="index" class="mb-2">
          <label class="text-justify">
            {{ `${index + 1}. ${question.name}` }}
          </label>

          <br>
          <div>
            <div class="mb-1">
              <label class="me-2">
                <input type="radio" :name="'options' + index" v-model="answers[index].isTrue" :value="true" required>
                Sí
              </label>
              <label>
                <input type="radio" :name="'options' + index" v-model="answers[index].isTrue" :value="false" required>
                No
              </label>

            </div>
            <div class="flex-grow-1">
              <small v-if="getAskDeepening(index)">
                <textarea required v-model="answers[index].value" class="form-control form-control-sm"
                  placeholder="Escriba aquí la profundización de su respuesta" />
              </small>

            </div>
          </div>
        </div>

        <button class="btn btn-primary" type="submit" :disabled="isUploading">
          <b-spinner v-if="isUploading" small />
          Enviar
        </button>

      </div>

    </b-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums';
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import BaseModal from '@/components/shared/Base-modal.vue';
import DocumentPdf from '@/components/shared/Document-pdf.vue';

export default {
  components: {
    AlertDismiss,
    BaseModal,
    DocumentPdf,
  },

  data() {
    return {
      isfetching: true,
      showModal: false,
      agreed: false,
      pdfUrl: "",
      selectedTemplate: null,
      templates: [],
      answers: [],
      isUploading: false,
    };
  },

  computed: {
    noTemplates() {
      return !this.isfetching && this.templates.length === 0;
    },
  },

  async mounted() {
    this.isfetching = true;
    await this.getTemplates();
    this.isfetching = false;
  },

  methods: {
    ...mapActions([
      "getTemplateDocumentUrl",
      "getAllStatementTemplatesForUser",
      "saveStatement",
    ]),

    async getTemplates() {
      this.isfetching = true;
      let result = await this.getAllStatementTemplatesForUser();

      if (result.isError) {
        this.$refs.alert.showAlert(result.message);
        this.isfetching = false;
        return;
      }

      this.templates = result.data;
      this.isfetching = false;
    },

    async openDocumentModal() {
      this.showModal = true;
      let result = await this.getTemplateDocumentUrl({ route: this.selectedTemplate.document.route });

      if (result.isError) {
        this.$refs.alert.showAlert(result.message);
        this.showModal = false;
        return;
      }

      this.pdfUrl = result.data;
    },

    resetAnswers() {
      this.answers = this.selectedTemplate.questions.map(question => {
        return {
          questionId: question.id,
          isTrue: null,
          value: ""
        }
      })
    },

    getAskDeepening(index) {
      return this.answers[index].isTrue && this.selectedTemplate.questions[index].deepening;
    },

    async onSubmit() {
      this.isUploading = true;
      let mappedAnswers = this.answers.map(answer => {
        return {
          questionId: answer.questionId,
          answerIsCorrect: answer.isTrue,
          answerTextDepth: answer.value
        }
      });

      let result = await this.saveStatement({
        statementId: this.selectedTemplate.id,
        questionStatements: mappedAnswers
      });

      if (result.isError) {
        this.$refs.alert.showAlert(result.message);
        this.isUploading = false;
        return;
      }

      this.$refs.alert.showAlert("Declaración enviada", "success");
      this.$eventBus.$emit(EventNames.CreatedStatement);
      this.isUploading = false;
      this.resetAnswers();
    },
  },

  watch: {
    selectedTemplate() {
      this.resetAnswers();
    }
  }
};
</script>